import React from 'react'
import popup from '~/views/Popup/popup'
import Spinner from '~/components/Spinner'
import { fetchDevices, activateDevice } from '../../redux/devices/helpers'
import { onUserAuth } from '../../redux/user/helpers'

class DeviceInfo extends React.Component {
	constructor() {
		super()
    this.state = { deviceCount: null, loading: false, message: null, devices: [] }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onKeyup = this.onKeyup.bind(this)
	}

  componentDidMount() {
    onUserAuth(user => this.getDevices(user))
  }

	getDevices(user) {
    if (!user) {
      this.setState({ deviceCount: null })
      return
    }

		fetchDevices(this.props.user.userId).then(response => {
      this.setState({ deviceCount: response.length, devices: response })
		})
  }

  handleSubmit(event){
    event.preventDefault()
    this.setState({
      loading: true
    })
    activateDevice(this.deviceCode.value.toUpperCase(), this.props.user.userId)
    .then(res=>{
      if(res.data && res.data.status === 'success'){
        this.setState({
          loading: false,
          message: 'Device has been Activated!',
        })
        this.getDevices(this.props.user)
        this.deviceCode.value = ''
        this.deviceMsg.classList.remove('error')
        setTimeout(_ => this.setState({message: null }), 3000)
      }
    })
    .catch(res => {
      this.setState({
        loading: false,
        message: res.response.data.errorMessage
      })
      this.deviceMsg.classList.add('error')
    })
  }

  onKeyup(){
    this.setState({
      message: null
    })
  }

	render() {

    if (!this.props.user)
      return null

    const buttonValue = this.state.loading ? <Spinner />: 'Activate'
    return (
      <section>
        <div className="title site-color">Device Management</div>
        <div className="detail">
        	<div className="title site-color">Num devices</div>
          <div className="main">
	        	<div className="key">{ this.state.deviceCount }</div>
	        </div>
          <div className="buttons">
            <div className="button" onClick={_ => popup.manageDevices({ devices: this.state.devices, getDevices: (user) => this.getDevices(user)}) }>Manage</div>
          </div>
          <div className="buttons">
            <form className="add-code-form" onSubmit={this.handleSubmit}>
              <input type="text" ref={e => this.deviceCode = e} className="device-code" onKeyUp={this.onKeyup} required/>
              <button type="submit" className="device-submit">{buttonValue}</button>
            </form> 
            {this.state.message && <span className="device-msg" ref={e => this.deviceMsg = e}>{this.state.message}</span> }
          </div>
        </div>
     	</section>
    )
  }
}

export default DeviceInfo;
